var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IndividualMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.005 9.79602C10.4866 9.79602 12.5078 7.77602 12.5078 5.29602C12.5078 2.81602 10.4866 0.796021 8.005 0.796021C5.52345 0.796021 3.50219 2.81602 3.50219 5.29602C3.50219 7.77602 5.52345 9.79602 8.005 9.79602ZM8.005 2.79602C9.38587 2.79602 10.5066 3.91602 10.5066 5.29602C10.5066 6.67602 9.38587 7.79602 8.005 7.79602C6.62414 7.79602 5.50344 6.67602 5.50344 5.29602C5.50344 3.91602 6.62414 2.79602 8.005 2.79602Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6779 11.296H3.33208C1.49093 11.296 0 12.796 0 14.626V15.796C0 16.346 0.450281 16.796 1.00063 16.796C1.55097 16.796 2.00125 16.346 2.00125 15.796V14.626C2.00125 13.886 2.60163 13.296 3.33208 13.296H12.6679C13.4084 13.296 13.9987 13.896 13.9987 14.626V15.796C13.9987 16.346 14.449 16.796 14.9994 16.796C15.5497 16.796 16 16.346 16 15.796V14.626C16 12.786 14.4991 11.296 12.6679 11.296H12.6779Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualMini);
export default __webpack_public_path__ + "static/media/IndividualMini.f6e678c1d514ab088e40ca7b024e57a7.svg";
export { ForwardRef as ReactComponent };